import "./IconMultiply.scss";

export const IconMultiply = () => {
  return <span className="IconMultiply"></span>;
};
